const doc = [({"da":({"js":({"bank_accounts":({"account_type_select":({"choose_account_type":"Vælg kontotype"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;